import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetDescriptionParams } from '../types/actionParams';

export class SetProjectDescriptionRequest extends Request<ISetDescriptionParams, IEmptyResult> {
  constructor(id: string, description: string) {
    super('setProjectDescription', {
      id: id,
      description: description
    });
  }
}
